import {Box, Stack, Typography, useTheme} from "@mui/material";
import RpIcon from "@/components/RpIcon";
import AppModal from "@/components/AppModal.tsx";
import React, {useEffect, useMemo, useState} from "react";
import {useTranslation} from "react-i18next";
import {useBoolean, useNetwork, usePrevious} from "ahooks";
import mobileClasses from "./mobile.module.css";
import {useSelector} from "react-redux";
import AppLoadingButton from "@/components/mui/LoadingButton";
import {dispatch} from "@/redux/store";
import {setWithdrawInfo} from "@/redux/slices/assets";
import {alpha} from "@mui/material/styles";
interface Props {
  selectedNetwork?: any,
  variety: any,
  paramDepositInfo: any,
  paramWithdrawInfo: any,
  onSelected: (network: any) => void
}

const SelectNetwork = (props: Props) => {
  const { variety, paramDepositInfo, paramWithdrawInfo, selectedNetwork, onSelected, onChange } = props;
  const theme = useTheme()
  const {t} = useTranslation();
  const { withdrawInfo } = useSelector((state) => state.assets);
  const [selected, setSelected] = useState(null);
  const [networkModalShow, networkModalShowOperate] = useBoolean(false);
  const preSelected = usePrevious(selected)
  useEffect(() => {
    if (selectedNetwork?.coin) {
      const _selected = paramWithdrawInfo?.coinList.find(_ => _.coin == selectedNetwork?.coin)
      setSelected(_selected)
      onSelected && onSelected(_selected)
    }
  }, [selectedNetwork, paramWithdrawInfo])

  useEffect(() => {
    if (!selected) {
      if (!withdrawInfo.network) {
        setSelected(paramWithdrawInfo?.coinList[0])
        onSelected && onSelected(paramWithdrawInfo?.coinList[0])
        dispatch(setWithdrawInfo({
          ...withdrawInfo,
          network: paramWithdrawInfo?.coinList[0],
        }))
      } else {
        setSelected(withdrawInfo.network)
        onSelected && onSelected(withdrawInfo.network)
        dispatch(setWithdrawInfo({
          ...withdrawInfo,
          network:  withdrawInfo.network,
        }))
      }
    }
  }, [paramWithdrawInfo?.coinList, withdrawInfo.network]);

  useEffect(() => {
    if (preSelected && selected && preSelected.coin != selected.coin) {
      onChange && onChange(selected)
    }
  }, [preSelected, selected]);

  // useEffect(() => {
  //   console.log(paramWithdrawInfo?.coinList, withdrawInfo.network)
  //   if (paramWithdrawInfo?.coinList && paramWithdrawInfo?.coinList.length > 0 && !withdrawInfo.network) {
  //     setSelected(paramWithdrawInfo?.coinList[0])
  //     onSelected && onSelected(paramWithdrawInfo?.coinList[0])
  //     dispatch(setWithdrawInfo({
  //       ...withdrawInfo,
  //       network: paramWithdrawInfo?.coinList[0],
  //     }))
  //   }
  // }, [paramWithdrawInfo?.coinList, withdrawInfo.network]);

  return (
    <>
      <Stack
        sx={theme => {
          return {
            height: '49px',
            padding: '0 16px',
            border: `0.5px solid ${theme.palette.text.tertiary}`,
            width: `100%`,
            borderRadius:'6px'
          }
        }}
        onClick={() => { networkModalShowOperate.setTrue() }}
        direction="row" alignItems="center" justifyContent="space-between">
        <Typography fontSize={'16px'}>
          {selected ? selected.displayName : t("please_select_network")}</Typography>
        <RpIcon
          icon={"arrow-down-simple"}
        />
      </Stack>
    <AppModal
    open={networkModalShow}
    onClose={networkModalShowOperate.setFalse}
    >
      <Stack className={mobileClasses.modal}>
        <Stack direction="row" className={mobileClasses.modalHeader}>
          <RpIcon icon={'close'} size={22} clickable onClick={() => { networkModalShowOperate.setFalse() }} />
          <Typography className={mobileClasses.modalTitle}>{withdrawInfo ? 'Withdraw' : 'Deposit'} {variety?.shortName}</Typography>
        </Stack>
        <Stack direction="column" alignItems="center" className={mobileClasses.modalContent}>
          <Stack gap="16px" direction="column" alignItems="center" className={mobileClasses.topBlock}>
            {variety && variety.varietyCode && <img src={`/images/coin/${variety.varietyCode.toLowerCase()}.svg`}
                             alt={`${variety.shortName}.png`}/>}
            <Typography
              sx={theme => ({
                fontSize: theme.typography.pxToRem(28),
                fontWeight: 700,
              })}
            >{t('select_a_network')}</Typography>
            <Typography
              sx={theme => ({
                fontSize: theme.typography.pxToRem(12),
                fontWeight: 500,
              })}
              align="center">{t('select_a_network_ensure')}</Typography>
          </Stack>
          <Stack gap={'8px'} sx={{width:'100%', padding: '16px'}}>
            <Typography>{t('network')}</Typography>
            <Stack gap="16px">
              {paramDepositInfo &&
                paramDepositInfo.addressList.map(_ => {
                  return (
                    <Stack
                      direction="column"
                      justifyContent="center"
                      key={_.coin}
                      onClick={() => {
                        setSelected(_)
                        networkModalShowOperate.setFalse()
                        onSelected && onSelected(_)
                      }}
                      sx={theme => {
                      return {
                        // padding: '6px',
                        paddingLeft: '16px',
                        height: '72px',
                        borderRadius: '2px',
                        backgroundColor: theme.palette.background.card,
                        position: 'relative',
                        overflow: 'hidden',
                        border: `1px solid transparent`,
                        borderColor: (selected && selected.coin == _.coin) ? theme.palette.text.primary : theme.palette.background.other1,
                        borderWidth: (selected && selected.coin == _.coin) ? '2px' : '1px'
                      }
                    }}>
                      {(selected && selected.coin == _.coin) &&
                        <>
                          <Stack
                            sx={{position: 'absolute', right: 0, top: 0,
                              width: '40px', height: '40px'
                            }}
                          >
                            <img
                              style={{position: 'absolute', right: -7, top: -7}}
                              src={`/images/rectangle.svg`}/>
                            <Box
                              sx={{position: 'absolute', right: 0, left: 0, zIndex: 3,
                                width: '40px', height: '40px',
                                textAlign: 'center',
                              }}
                            >
                              <i
                                style={{
                                  fontSize: '22px',
                                  height: '22px',
                                  lineHeight: '22px',
                                  color: theme.palette.background.default,
                                  position: 'absolute',
                                  right: 0,
                                }}
                                color={theme.palette.background.default} className="iconfont icon-check" />
                            </Box>
                          </Stack>
                        </>
                      }
                      <Stack>
                        <Typography
                          sx={theme => {
                            return {
                              fontSize: theme.typography.pxToRem(14),
                              fontFamily: 'Urbanist-bold'
                            }
                          }}
                        >{variety?.shortName} - {_.displayName}</Typography>
                        <Typography
                          sx={theme => {
                            return {
                              fontSize: theme.typography.pxToRem(12),
                            }
                          }}
                        >Minimum Deposit Amount: {depositInfo.depositMin} USDT</Typography>
                        <Typography
                          sx={theme => {
                            return {
                              fontSize: theme.typography.pxToRem(12),
                            }
                          }}
                        >Deposit arrival: {_.confirmations} confirmations</Typography>
                      </Stack>
                    </Stack>
                  )
                })
              }
              {paramWithdrawInfo &&
                paramWithdrawInfo.coinList.map(_ => {
                  return (
                    <Stack
                      direction="column"
                      justifyContent="center"
                      key={_.coin}
                      onClick={() => {
                        setSelected(_)
                        networkModalShowOperate.setFalse()
                        onSelected && onSelected(_)
                      }}
                      sx={theme => {
                        return {
                          // padding: '6px',
                          paddingLeft: '16px',
                          height: '72px',
                          borderRadius: '2px',
                          backgroundColor: theme.palette.background.card,
                          position: 'relative',
                          overflow: 'hidden',
                          border: `1px solid transparent`,
                          borderColor: (selected && selected.coin == _.coin) ? theme.palette.text.primary : theme.palette.background.other1,
                          borderWidth: (selected && selected.coin == _.coin) ? '2px' : '1px'
                        }
                      }}>
                      {(selected && selected.coin == _.coin) &&
                        <>
                          <Stack
                            sx={{position: 'absolute', right: 0, top: 0,
                              width: '40px', height: '40px'
                            }}
                          >
                            <img
                              style={{position: 'absolute', right: -7, top: -7}}
                              src={`/images/rectangle.svg`}/>
                            <Box
                              sx={{position: 'absolute', right: 0, left: 0, zIndex: 3,
                                width: '40px', height: '40px',
                                textAlign: 'center',
                              }}
                            >
                              <i
                                style={{
                                  fontSize: '22px',
                                  height: '22px',
                                  lineHeight: '22px',
                                  color: theme.palette.background.default,
                                  position: 'absolute',
                                  right: 0,
                                }}
                                color={theme.palette.background.default} className="iconfont icon-check" />
                            </Box>
                          </Stack>
                        </>
                      }
                      <Stack>
                        <Typography
                          sx={theme => {
                            return {
                              fontSize: theme.typography.pxToRem(14),
                              fontFamily: 'Urbanist-bold'
                            }
                          }}
                        >{variety?.shortName} - {_.displayName}</Typography>
                        <Typography
                          sx={theme => {
                            return {
                              fontSize: theme.typography.pxToRem(12),
                            }
                          }}
                        >Minimum Withdraw Amount: {_.withdrawMin} {variety?.shortName}</Typography>
                      </Stack>
                    </Stack>
                  )
                })
              }
            </Stack>
            {/*<AppLoadingButton*/}
            {/*  sx={{ marginTop: '16px' }}*/}
            {/*  variant="contained" fullWidth*/}
            {/*  onClick={() => {*/}
            {/*    networkModalShowOperate.setFalse()*/}
            {/*    onSelected && onSelected(selected)*/}
            {/*  }}*/}
            {/*>{t('confirm')}</AppLoadingButton>*/}
          </Stack>
        </Stack>
      </Stack>
    </AppModal>
    </>

  )
}

export default SelectNetwork;